// @ts-nocheck
/* eslint-enable */
// App
import { useSelector } from 'react-redux';

export const useBedButtonLabel = ({ bedsOnly = false } = {}) => {
  // Redux
  const bedState = useSelector((state) => state.filter.bedrooms);
  const bathState = useSelector((state) => state.filter.bathrooms);
  const DEFAULT_LABEL = bedsOnly ? 'All beds' : 'All beds, all baths';

  const getButtonLabel = () => {
    const isExact = bedState.isExact;
    const bedIdentifiers = Object.keys(bedState);
    const activeBeds = bedIdentifiers.filter((beds) => {
      return bedState[beds];
    })[0];
    const bathIdentifiers = Object.keys(bathState);
    const activeBaths = bathIdentifiers.filter((beds) => {
      return bathState[beds];
    })[0];

    const BED_LABEL_MAP = {
      anyOrStudio: isExact ? 'Studio' : 'All beds',
      oneOrMore: isExact ? '1 bed' : '1+ beds',
      twoOrMore: isExact ? '2 beds' : '2+ beds',
      threeOrMore: isExact ? '3 beds' : '3+ beds',
      fourOrMore: isExact ? '4 beds' : '4+ beds',
    };

    const BATH_LABEL_MAP = {
      any: 'all baths',
      oneOrMore: '1+ baths',
      oneHalfOrMore: '1.5+ baths',
      twoOrMore: '2+ baths',
      threeOrMore: '3+ baths',
      fourOrMore: '4+ baths',
    };

    if (activeBeds === 'anyOrStudio' && activeBaths === 'any') {
      return DEFAULT_LABEL;
    } else {
      return bedsOnly ? BED_LABEL_MAP[activeBeds] : `${BED_LABEL_MAP[activeBeds]}, ${BATH_LABEL_MAP[activeBaths]}`;
    }
  };

  const getButtonStatus = (label) => {
    return label !== DEFAULT_LABEL;
  };

  return [getButtonLabel, getButtonStatus];
};
